import { useContext } from 'react';
import { AuthClassification } from 'src/hooks/auth/auth.interface';
import { ComponentTypes } from 'src/interfaces/ComponentTypesList';

import { AuthDataProvider } from '../authProvider';
import type { ProductsSidebarSetting } from './ProductsSidebar.interface';

export const useProductsSidebar = (componentType: ComponentTypes) => {
  const { userRole } = useContext(AuthDataProvider);

  const isNotOwnerOperator = userRole !== AuthClassification.OWNER_OPERATOR;

  const initialSettings: ProductsSidebarSetting = {
    showProductImages: false,
    enableSelectProductImages: true,
    enableUploadProductImages: isNotOwnerOperator,
    showProductImageController: false,
    showProductPositionsController: false,
    showProductImageAccordion: false,
    showProductBackups: true,
    showAddGroupButton: false,
    showRemoveGroupButton: isNotOwnerOperator,
    showRemoveColumnButton: isNotOwnerOperator,
    showAnimationController: false,
    showGroupController: false,
    showGroupComboController: false,
    enableNavigateToSetting: isNotOwnerOperator,
    enableColumnList: false,
    showSizeStylesController: false,
    showSupportingProductImageAccordion: false,
    showFlexWrap: false,
  };

  const componentSettings = {
    [ComponentTypes.SINGLE_SHELF]: {
      showProductImages: true,
      showProductImageController: true,
    },
    [ComponentTypes.PROMOTIONAL_SPACE]: {
      showProductPositionsController: true,
      showProductBackups: false,
      showAnimationController: isNotOwnerOperator,
      showFlexWrap: true,
    },
    [ComponentTypes.LISTING_VISUALS_GALLERY]: {
      showProductImages: true,
      showProductImageController: true,
      showAddGroupButton: isNotOwnerOperator,
      showRemoveGroupButton: true,
      showGroupController: isNotOwnerOperator,
      enableColumnList: true,
    },
    [ComponentTypes.LISTING_WITH_OPTIONAL_VISUALS]: {
      showProductImages: true,
      showProductImageController: true,
      showAddGroupButton: isNotOwnerOperator,

      showGroupController: isNotOwnerOperator,
      showZIndex: true,
    },
    [ComponentTypes.COMBO_STYLE]: {
      showProductImageAccordion: true,
      showSupportingProductImageAccordion: true,
      showAddGroupButton: isNotOwnerOperator,
      showGroupController: isNotOwnerOperator,
      showGroupComboController: true,
      showSizeStylesController: true,
    },
    [ComponentTypes.PROMOTIONAL_COMPONENT]: {
      showFlexWrap: true,
    },
  };

  const settings =
    componentSettings[componentType as keyof typeof componentSettings] || {};

  return {
    showComponents: {
      ...initialSettings,
      ...settings,
    } as ProductsSidebarSetting,
  };
};
